import { EntityModel, StringValue, TenantPath } from '@msdk/definitions'
import { useCallback } from 'react'
import { useRecoilValue } from 'recoil'

import { useApiClient } from '../../react/hooks'
import { useEntityMetadata } from '../metadata/hooks'
import { $sitemap, $sitemapItems } from './selectors'

export function useSitemap(sitemapName: string) {
  const sitemap = useRecoilValue($sitemap(sitemapName))
  return sitemap
}

export function useHomeSitemap() {
  const apiClient = useApiClient()
  const model = useEntityMetadata('UI_CONFIGURATION') as EntityModel
  return useCallback(async () => {
    const tenantPath = new TenantPath()
    let sitemapName = tenantPath.homeSitemap
    if (!sitemapName?.trim()) {
      const result = await apiClient.entity.getSingleton('CMPS', '', model)
      const entity = result.entities[0]
      const home = entity.fields['HOME_SITEMAP'] as StringValue
      sitemapName = home?.value ? home.value : 'WebMainArea'
    }
    return sitemapName
  }, [apiClient, model])
}

export function useSitemapItems() {
  const items = useRecoilValue($sitemapItems)
  return items
}
